'use client';

import * as Sentry from '@sentry/nextjs';
import { USE_SENTRY } from '@/enviroment';
import {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_CLIENT_CONFIG,
  IGNORED_ERRORS,
} from '../sentry.keys';

/**
 * 🌐 Initialize Sentry for Client Components
 */
export function initClientSentry(): void {
  if (!USE_SENTRY) {
    // eslint-disable-next-line no-console
    console.info('ℹ️  Sentry disabled for environment:', SENTRY_ENVIRONMENT);
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    // 🔒 Tunnel requests through Next.js to bypass ad blockers
    tunnel: '/monitoring',

    // 📊 Performance Monitoring
    ...SENTRY_CLIENT_CONFIG,
    enableLogs: true,
    // 🔐 Enable request header capture (required for context extraction)
    sendDefaultPii: true,
    // 🔌 Integrations
    integrations: [
      Sentry.replayIntegration({
        // NOTE: This will disable built-in masking.
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['error'] }),
      Sentry.feedbackIntegration({
        colorScheme: 'system',
        autoInject: false, // We'll manually trigger it on error pages
        showBranding: false,
        enableScreenshot: true,
      }),
    ],

    // 🔇 Filter noise
    ignoreErrors: IGNORED_ERRORS,
  });
}
